import React, { useContext, useState } from 'react';
import { clientInfoSchema } from '../../Validations/User';
import { useFormik } from 'formik';
import { Context } from '../../Context/Context';
import { updateUserApi } from '../../Constants';
import { stateUS } from 'states';
import { STATE_SELECTION_ENABLED, DEFAULT_STATE } from 'Constants';
import FieldError from 'Components/Element/FieldError';

function ClientDetailsEdit({setShowEdit}) {
  const {userDetails, setUpdateLoggedinData, makeApiCallFunc} = useContext(Context);
  const [states] = useState(stateUS);

  const onSubmit = (values) => {
    const postData = {...values, user:userDetails._id};

    makeApiCallFunc(
      updateUserApi,
      postData,
      ({data})=>
      {
          setUpdateLoggedinData((prev) => !prev)
          setShowEdit(false);

      },
      (error) => {
        setApiError(error?.response?.data?.message);
    }
      )
  }
  const handleFocus = () => 
  {
    setApiError("");
  }
   const [apiError, setApiError] = useState("");
   const {values, errors, touched, handleBlur, handleChange, handleSubmit} = useFormik({
      enableReinitialize: true,
      initialValues : {
        email: userDetails?.email,
        firstName :userDetails?.firstName,
        lastName :userDetails?.lastName,
        age :userDetails?.age,
        phoneNumber :userDetails?.phoneNumber,
        city :userDetails?.city,
        state : STATE_SELECTION_ENABLED ? userDetails?.state : DEFAULT_STATE
    },
      validationSchema : clientInfoSchema,
      onSubmit,
  })

  const inputClass = "w-full box-border";
  const inputStyle = {font:"400 14.5px/1 'IBM Plex Sans',sans-serif", padding:'12px 13px', border:'1.5px solid rgba(20,33,61,.18)', borderRadius:'3px', background:'#fffdf8'};
  const labelStyle = {display:'block', font:"500 12.5px/1 'IBM Plex Sans',sans-serif", color:'#14213d', marginBottom:'7px'};

  return (
    <div className='w-full font-plexsans'>
      <h2 style={{margin:'0 0 4px', font:"400 22px/1.25 'Spectral',serif", color:'#14213d'}}>Edit profile</h2>
      <p style={{margin:'0 0 24px', font:"400 13.5px/1.5 'IBM Plex Sans',sans-serif", color:'rgba(20,33,61,.55)'}}>This information helps us match you with the right attorneys.</p>
      {apiError && <FieldError>{apiError}</FieldError>}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-4 mb-6 mt-4">
        <div>
          <label style={labelStyle}>First name</label>
          <input type="text" name="firstName" placeholder="First name" className={inputClass} style={inputStyle}
            value={values.firstName} onChange={handleChange} onBlur={handleBlur} onFocus={handleFocus}/>
          {errors.firstName && touched.firstName && <FieldError>{errors.firstName}</FieldError>}
        </div>
        <div>
          <label style={labelStyle}>Last name</label>
          <input type="text" name="lastName" placeholder="Last name" className={inputClass} style={inputStyle}
            value={values.lastName} onChange={handleChange} onBlur={handleBlur} onFocus={handleFocus}/>
          {errors.lastName && touched.lastName && <FieldError>{errors.lastName}</FieldError>}
        </div>
        <div className="md:col-span-2">
          <label style={labelStyle}>Email</label>
          <input type="text" name="email" placeholder="example@email.com" className={inputClass} style={inputStyle}
            value={values.email} onChange={handleChange} onBlur={handleBlur} onFocus={handleFocus}/>
          {errors.email && touched.email && <FieldError>{errors.email}</FieldError>}
        </div>
        <div>
          <label style={labelStyle}>Phone number</label>
          <input type="text" name="phoneNumber" placeholder="(123) 456-7890" className={inputClass} style={inputStyle}
            value={values.phoneNumber} onChange={handleChange} onBlur={handleBlur} onFocus={handleFocus}/>
          {errors.phoneNumber && touched.phoneNumber && <FieldError>{errors.phoneNumber}</FieldError>}
        </div>
        <div>
          <label style={labelStyle}>Age <span style={{color:'rgba(20,33,61,.4)', fontWeight:400}}>(optional)</span></label>
          <input type="text" name="age" placeholder="Your age" className={inputClass} style={inputStyle}
            value={values.age} onChange={handleChange} onBlur={handleBlur} onFocus={handleFocus}/>
          {errors.age && touched.age && <FieldError>{errors.age}</FieldError>}
        </div>
        <div>
          <label style={labelStyle}>City <span style={{color:'rgba(20,33,61,.4)', fontWeight:400}}>(optional)</span></label>
          <input type="text" name="city" placeholder="City" className={inputClass} style={inputStyle}
            value={values.city} onChange={handleChange} onBlur={handleBlur} onFocus={handleFocus}/>
          {errors.city && touched.city && <FieldError>{errors.city}</FieldError>}
        </div>
        {STATE_SELECTION_ENABLED &&
        <div>
          <label htmlFor="state" style={labelStyle}>State <span style={{color:'rgba(20,33,61,.4)', fontWeight:400}}>(optional)</span></label>
          <select id="state"
            value={values.state}
            onChange={handleChange}
            onBlur={handleBlur}
            onFocus={handleFocus}
            name="state"
            className={inputClass}
            style={{...inputStyle, color: values.state ? '#14213d' : 'rgba(20,33,61,.4)'}}>
              <option value="">Choose state</option>
              {states.map((state) => <option key={state} value={state}>{state}</option>)}
          </select>
        </div>}
      </div>
      <div className='flex justify-between'>
        <span
        className="cursor-pointer rounded-sm"
        style={{font:"500 12.5px/1 'IBM Plex Sans',sans-serif", color:'rgba(20,33,61,.55)', border:'1px solid rgba(20,33,61,.2)', padding:'12px 22px'}}
        onClick = {()=> setShowEdit(false)}
        >Back</span>
        <button
        className="cursor-pointer rounded-sm transition-colors"
        style={{font:"500 12.5px/1 'IBM Plex Sans',sans-serif", color:'#fffdf8', background:'#8a6231', border:'none', padding:'12px 26px'}}
        onMouseEnter={(e) => e.currentTarget.style.background = '#6d4c25'}
        onMouseLeave={(e) => e.currentTarget.style.background = '#8a6231'}
        onClick={handleSubmit}>Save changes</button>
      </div>
    </div>
  )
}

export default ClientDetailsEdit
